import { apiClient } from "./apiClient";

export type SigMxDumpVersion = "odoo_16" | "odoo_18";

export interface SigMxDownloadTokenResponse {
  ready: boolean;
  generating: boolean;
  token?: string;
  fileName?: string;
  error?: string;
}

/**
 * Sig-mx — descarga de copias de las bases odoo_16 y odoo_18.
 * El token efímero existe porque el navegador no adjunta el JWT en una
 * descarga nativa: primero se pide el token (petición autenticada) y luego
 * el navegador descarga con GET /api/sig-mx/download?token=...
 */
export const sigMxService = {
  async requestDownloadToken(
    version: SigMxDumpVersion,
  ): Promise<SigMxDownloadTokenResponse> {
    const response = await apiClient.post<SigMxDownloadTokenResponse>(
      `/sig-mx/dumps/${version}/download-token`,
    );
    return response.data;
  },

  buildDownloadUrl(token: string): string {
    return `/api/sig-mx/download?token=${encodeURIComponent(token)}`;
  },
};
